var _linearGradient, _clipPath, _radialGradient, _clipPath2, _circle, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 129 41.34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 28.478,
    x2: 28.478,
    y1: 28.858,
    y2: -12.277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e52724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#791909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#791909"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.95,
    cy: 21.45,
    r: 19.83
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 20.8832,
    cy: 12.9594,
    gradientUnits: "userSpaceOnUse",
    r: 31.6768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#e52724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#791909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e1f15"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.45 21.44a3.49 3.49 0 0 1 3.5-3.5h3.5v-3.5a3.5 3.5 0 1 1 7 0v3.5h3.5a3.5 3.5 0 1 1 0 7h-3.5v3.5a3.5 3.5 0 0 1 -7 0v-3.5h-3.5a3.5 3.5 0 0 1 -3.5-3.5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.89,
    cy: 21.45,
    fill: "url(#a)",
    r: 19.83
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.89 41.34a19.89 19.89 0 1 1 19.88-19.89 19.91 19.91 0 0 1 -19.88 19.89zm0-39.65a19.77 19.77 0 1 0 19.76 19.76 19.79 19.79 0 0 0 -19.76-19.77z",
    fill: "#791909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.95,
    cy: 19.83,
    fill: "url(#c)",
    r: 19.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.01,
    cy: 13.34,
    fill: "#f8bdaf",
    fillOpacity: 0.25,
    rx: 14.6,
    ry: 10.27
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.45 21.44a3.49 3.49 0 0 1 3.5-3.5h3.5v-3.5a3.5 3.5 0 1 1 7 0v3.5h3.5a3.5 3.5 0 1 1 0 7h-3.5v3.5a3.5 3.5 0 0 1 -7 0v-3.5h-3.5a3.5 3.5 0 0 1 -3.5-3.5z",
    fill: "#791909"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.06 22a3.5 3.5 0 0 1 3.5-3.5h3.44v-3.5a3.5 3.5 0 0 1 7 0v3.5h3.5a3.5 3.5 0 1 1 0 7h-3.5v3.5a3.5 3.5 0 0 1 -7 0v-3.5h-3.44a3.5 3.5 0 0 1 -3.5-3.5z",
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m127.35 12a1.43 1.43 0 1 0 1.43 1.43 1.43 1.43 0 0 0 -1.43-1.43zm0-.22a1.65 1.65 0 1 1 -1.65 1.65 1.65 1.65 0 0 1 1.65-1.63zm.48 2.61-.5-.81h-.33v.82h-.26v-1.88h.47c.46 0 .68.18.68.54a.51.51 0 0 1 -.11.32.47.47 0 0 1 -.26.18l.55.87zm-.83-1.64v.62h.18a.58.58 0 0 0 .34-.08.3.3 0 0 0 .11-.27.25.25 0 0 0 -.11-.23.71.71 0 0 0 -.36-.07z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m58.49 26.58-.96-8.72-4.12 8.72h-.73l-4.48-8.72-.78 8.72h-1.04l1.21-11.51h.95l4.77 9.39 4.47-9.39h.98l1.3 11.51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m68.75 26.58h-6.26v-11.44h6l-.12.83-4.29.06v4.05l4.06.04-.12.74-3.94.09v4.73l4.78.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.6 25.73.8.1q.44 0 1 0a9.14 9.14 0 0 0 2-.17 3.89 3.89 0 0 0 1.44-.58 2.67 2.67 0 0 0 .54-.52 3.17 3.17 0 0 0 .47-.87 6.85 6.85 0 0 0 .34-1.3 11 11 0 0 0 .13-1.84 5.52 5.52 0 0 0 -.4-2.24 3.85 3.85 0 0 0 -2.59-2.26 6.67 6.67 0 0 0 -1.79-.24h-.67-.48-.38-.4zm-1.6-10.49.87-.08 1-.07 1.13-.09h1a8.37 8.37 0 0 1 2.43.33 5 5 0 0 1 1.87 1 4.48 4.48 0 0 1 1.24 1.67 6.16 6.16 0 0 1 .46 2.41 7.89 7.89 0 0 1 -.39 2.53 5.16 5.16 0 0 1 -3.1 3.27 7.15 7.15 0 0 1 -2.69.46q-1 0-2-.06c-.67 0-1.26-.08-1.76-.13z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m83.55 15.14h1.59v11.44h-1.59z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m92.28 26.74a5 5 0 0 1 -2.15-.42 3.75 3.75 0 0 1 -1.44-1.2 5.11 5.11 0 0 1 -.81-1.86 10.9 10.9 0 0 1 -.25-2.43 6.91 6.91 0 0 1 .48-2.74 5 5 0 0 1 1.25-1.8 4.64 4.64 0 0 1 1.73-1 6.49 6.49 0 0 1 1.91-.29h.79l.85.06.77.07.57.08-.42 1.35-.64-.15-.92-.14-.93-.12a7.28 7.28 0 0 0 -.77-.05 5.75 5.75 0 0 0 -1.18.11 2.31 2.31 0 0 0 -.92.43 2.34 2.34 0 0 0 -.72 1.48 15 15 0 0 0 -.21 2.7 7.63 7.63 0 0 0 .74 3.75 2.55 2.55 0 0 0 2.38 1.28h1s.66-.05 1-.1.64-.1 1-.16.6-.14.88-.23v.59a7.19 7.19 0 0 1 -.91.35q-.49.15-1 .26c-.34.07-.68.12-1 .16a9.23 9.23 0 0 1 -1.08.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.63 26.58-1.47-4.2-4.52.05-1.57 4.14h-1.17l4.65-11.35 1.37-.39 4.35 11.74zm-1.71-4.94-1.92-5.35-2 5.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.06 21.75h-1.65v4.83h-1.59v-11.41c.48 0 1-.07 1.59-.09s1.15 0 1.7 0a6.55 6.55 0 0 1 1.77.21 3.4 3.4 0 0 1 1.25.61 2.45 2.45 0 0 1 .73 1 3.42 3.42 0 0 1 .24 1.32 3.65 3.65 0 0 1 -.2 1.27 3.28 3.28 0 0 1 -.53 1 3.21 3.21 0 0 1 -.78.7 5.15 5.15 0 0 1 -.94.48l1 1.68a12.87 12.87 0 0 0 1 1.4 5.08 5.08 0 0 0 1 1 1.84 1.84 0 0 0 1.07.36h.11v.5a3.43 3.43 0 0 1 -.64.14 5.53 5.53 0 0 1 -.79.06 2.77 2.77 0 0 1 -1-.15 2.06 2.06 0 0 1 -.78-.57 7.55 7.55 0 0 1 -.83-1.15q-.45-.74-1.1-1.91zm-1.15-.8a9.94 9.94 0 0 0 1.74-.12 3 3 0 0 0 1-.34 1.23 1.23 0 0 0 .3-.27 1.49 1.49 0 0 0 .24-.43 3.21 3.21 0 0 0 .15-.63 6.77 6.77 0 0 0 .05-.9 2.85 2.85 0 0 0 -.2-1.12 1.84 1.84 0 0 0 -.56-.75 2.36 2.36 0 0 0 -.88-.42 4.8 4.8 0 0 0 -1.18-.13h-.57l-.59.05v5.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.58 26.58h-6.26v-11.44h6l-.12.83-4.28.06v4.05l4.05.04-.12.74-3.93.09v4.73l4.77.09z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m46.38 28.06h79.31v.66h-79.31z",
    fill: "#e52724"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicare);
export default __webpack_public_path__ + "static/media/medicare.631c43a52deefb5bdda2d5e974a3022a.svg";
export { ForwardRef as ReactComponent };